import { SpaceXxs, SpaceLg, ColorWhite } from "@nxt-costco-com/forge-design-tokens";
const skipLinkStyles = {
  display: "block",
  position: "absolute",
  top: "auto",
  left: -999,
  textAlign: "center",
  overflow: "hidden",
  clip: "rect(0,0,0,0)",
  border: 0,
  "&:focus": {
    backgroundColor: ColorWhite,
    left: "3px",
    // account for focus ring
    top: "3px",
    height: "auto",
    width: "30%",
    zIndex: 999,
    clip: "auto",
    padding: `${SpaceXxs} ${SpaceLg}`
  },
  "&:visited": {
    textDecoration: "none"
  }
};
export {
  skipLinkStyles
};
